import { buildHourOptions, buildMinuteOptions } from '../../utils/time';

interface TimePickerProps {
  hour: number;
  minute: string;
  ampm: string;
  onHourChange: (h: number) => void;
  onMinuteChange: (m: string) => void;
  onAmpmChange: (a: string) => void;
  disabled?: boolean;
  fullSize?: boolean;
  id?: string;
}

const hourOptions = buildHourOptions();
const minuteOptions = buildMinuteOptions();

export function TimePicker({
  hour, minute, ampm, onHourChange, onMinuteChange, onAmpmChange, disabled, fullSize, id,
}: TimePickerProps) {
  return (
    <div className={`time-picker-group${fullSize ? ' time-picker-group--full' : ''}`} id={id}>
      <select value={hour} onChange={(e) => onHourChange(Number(e.target.value))} disabled={disabled}>
        {hourOptions.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <span className="time-picker-sep">:</span>
      <select value={minute} onChange={(e) => onMinuteChange(e.target.value)} disabled={disabled}>
        {minuteOptions.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <select value={ampm} onChange={(e) => onAmpmChange(e.target.value)} disabled={disabled}>
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}
